import ApprovalIcon from "@mui/icons-material/Approval";
import { ATTESTATIONS, StudentServicePath } from "utils/constants";
import ListAttestations from "./List";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <ApprovalIcon />,
  name: StudentServicePath + ATTESTATIONS,
  title: "Заверки",
  list: <ListAttestations />,
  //   create: <CreateExams />,
  //   createPermission: permissions.canCreateExams,
  //   edit: <EditExams />,
  //   editPermission: permissions.canUpdateExams,
  //   show: <ShowExams />,
  //   showPermission: permissions.canPreviewExams,
  permission: permissions.canPreviewAttestations,
};
